import { useState, useEffect, useCallback, useMemo } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface ProjectCommunicationSignals {
  tenant_id: string;
  project_id: string;
  computed_at: string;
  window_start: string | null;
  window_end: string | null;
  unanswered_count: number;
  avg_response_time_seconds: number | null;
  escalation_count: number;
  email_volume: number;
  volume_trend: string | null;
}

export const useProjectCommunicationSignals = () => {
  const [signals, setSignals] = useState<ProjectCommunicationSignals[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('project_communication_signals')
      .select('*');

    if (error) {
      console.error('Failed to load project communication signals:', error);
    } else {
      setSignals((data as ProjectCommunicationSignals[]) || []);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const getByProjectId = useCallback(
    (projectId: string): ProjectCommunicationSignals | undefined => {
      return signals.find((signal) => signal.project_id === projectId);
    },
    [signals],
  );

  return { signals, loading, getByProjectId, reload: load };
};
